import React from 'react';
import { Box, Button, CardActions, Icon, Typography } from '@material-ui/core';
import { CoreEvent } from '@sierralabs/core-ui';
import { useSubscribeComponentChanges } from '../../hooks/component/useSubscribeComponentChanges';
import { useSiteContext } from '../../SiteContext';
import SlotRenderer from '../renderers/SlotRenderer';
import { SiteComponent } from '../SiteComponentPlugin';
import { AssignEntityEvent, AssignEntityWarning, useAssignEntityComponent, useAssignEntityDisabled } from './AssignEntityPlugin';
import { SiteButtonConfigurator } from './SiteButtonPlugin';
export const AssignEntityCardActions = props => {
    const component = useSubscribeComponentChanges(AssignEntityCardActionsPlugin, props);
    const { editing, isHover, hoverProps } = useSiteContext();
    const assignEntity = useAssignEntityComponent(component);
    const { disabled } = useAssignEntityDisabled(assignEntity);
    const { text, variant, size, color, startIcon, endIcon } = component.props || {};
    const classes = ['assign-entity-card-actions'];
    if (isHover(component)) {
        classes.push('component-hover');
    }
    return (React.createElement(SiteComponent, Object.assign({ plugin: AssignEntityCardActionsPlugin }, props),
        React.createElement(CardActions, Object.assign({ className: classes.join(' ') }, hoverProps(component)),
            React.createElement(Button, { size: size, disabled: disabled, color: color || 'primary', variant: variant || 'outlined', startIcon: startIcon && React.createElement(Icon, null, startIcon), endIcon: endIcon && React.createElement(Icon, null, endIcon), onClick: () => {
                    if (!editing && (assignEntity === null || assignEntity === void 0 ? void 0 : assignEntity.id)) {
                        CoreEvent.dispatch(AssignEntityEvent.OpenDialog, { id: assignEntity.id });
                    }
                } }, text || 'Assign Entity'),
            React.createElement(SlotRenderer, { component: component, slot: 'content' }))));
};
export const AssignEntityCardActionsConfigurator = props => {
    return (React.createElement(React.Fragment, null,
        React.createElement(AssignEntityWarning, { component: props.component }),
        React.createElement(Box, { mt: 1 },
            React.createElement(Typography, { variant: 'overline' }, "Assign Button")),
        React.createElement(SiteButtonConfigurator, Object.assign({ hideEvents: true }, props))));
};
export const AssignEntityCardActionsPlugin = {
    name: 'Assign Entity Card Actions',
    type: 'assign-entity-card-actions',
    component: AssignEntityCardActions,
    configurator: AssignEntityCardActionsConfigurator,
    slots: [{ name: 'Content', type: 'component-stack', slot: 'content' }]
};
//# sourceMappingURL=AssignEntityCardActionsPlugin.js.map